export function assistantSuggestions(t) {
  return [1, 2, 3].map(index => t(`assistant.suggestion${index}`));
}
